<template>
  <!-- <div class="tabs"> -->
  <cube-tab-bar class="tab" v-model="activeVal" :data="tabs" @change="changeHandler">
  </cube-tab-bar>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'FootNav',
  props: {
    tabs: {
      label: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
    },
    activeDefault: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeVal: this.activeDefault,
    }
  },
  watch: {
    activeDefault(newValue, oldValue) {
      this.activeVal = newValue;
    },
    // changeHandler(label) {
    //   this.$emit('childLabel', label)
    //   // console.log('子组件', label)
    // },
  },
  methods: {
    changeHandler(label) {
      this.$emit('childLabel', label)
      // console.log('子组件', label)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";
.tabs {
  margin-top: rem(30);
  z-index: 2;
  background-color: #f5f5f5;
}
.tab {
  background-color: #fff;
  z-index: 2;
}
</style>




// WEBPACK FOOTER //
// src/views/FootNav.vue